import React, { useState } from "react";
import Card from "../Card/Card.jsx";
import { player_sidebar_title } from "./sidebar.json";
import btn_play from "./icons/play.svg";
import btn_pause from "./icons/pause.svg";

import "./sidebar.css";
import "./sidebar-player.css";

const trackList = [
  {
    src: "CD6/01_andelove.mp3",
    title: "01 - Andelove, andelove",
    playing: false,
  },

  {
    src: "CD6/09_andele_radost_jmeli.mp3",
    title: "09 - Andele radost jmeli",
    playing: false,
  },

  {
    src: "CD6/16_vanocni_noc.mp3",
    title: "16 - Vanocni noc",
    playing: false,
  },

  {
    src: "CD6/23_zvani_vseho_stvoreni.mp3",
    title: "23 - Zvani vseho stvoreni",
    playing: false,
  },
];

const SidebarPlayer = ({ lang }) => {
  const [play, setPlay] = useState(false);
  const [lastPlayingTrack, setLastPlayingTrack] = useState(-1);

  const stopLastPlaying = (idTrack) => {
    trackList[idTrack].playing = false;
  };

  const onPlay = (idTrack) => {
    // check if track chnaged
    let trackChanged = !(idTrack === lastPlayingTrack);

    // reset state of lastPlaying
    if (trackChanged & (lastPlayingTrack > -1)) {
      trackList[lastPlayingTrack].playing = false;
    }

    // change playing state
    let isPlaying = trackList[idTrack].playing;
    trackList[idTrack].playing = !isPlaying;

    setLastPlayingTrack(idTrack);
    setPlay(!play);

    // play or stop
    const x = document.getElementById("myAudio");
    if (trackChanged) {
      x.src = "/mp3/" + trackList[idTrack].src;
    }
    trackList[idTrack].playing ? x.play() : x.pause();

    x.onended = function () {
      stopLastPlaying(idTrack);
      if (trackList.length > idTrack + 1) onPlay(idTrack + 1);
    };
  };

  return (
    <Card styleProps="sidebarCard">
      <audio id="myAudio">
        <source src="/mp3/CD1/01_-_Gavotte_en_Rondeau.mp3" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>{" "}
      <div className="sidebarHeader">
        <span>{player_sidebar_title[lang]} </span>
      </div>
      <div className="sidebar-player-list">
        <ul>
          {trackList.map((track, idx) => (
            <li key={idx}>
              <img
                src={track.playing ? btn_pause : btn_play}
                alt="play"
                onClick={() => onPlay(idx)}
              />{" "}
              {track.title}
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
};

export default SidebarPlayer;



// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/SidebarPlayer.jsx